import React from "react";
import MailOutlineIcon from "@material-ui/icons/MailOutline";

const SeenIcon = () => <MailOutlineIcon fontSize="small" />;

export default SeenIcon;
